/* eslint-disable @typescript-eslint/indent */
import { CREATE_PAYMENT_METHOD_MUTATION } from './useCreatePaymentMethod.graphql';
import {
  ICreatePaymentMethodMutationGraphQLResponse,
  ICreatePaymentMethodMutationVariables,
  IHandleCreatePaymentMethodParams,
  IUseCreatePaymentMethodOptions,
  IUseCreatePaymentMethod,
} from './useCreatePaymentMethod.interfaces';

import { useMuriquiMutation } from '../../apollo';

const useCreatePaymentMethod = (options?: IUseCreatePaymentMethodOptions): IUseCreatePaymentMethod => {
  const { mutation, onCompleted, onError, token } = options ?? ({} as IUseCreatePaymentMethodOptions);

  const [executeCreatePaymentMethod, { loading: isLoading }] = useMuriquiMutation<
    ICreatePaymentMethodMutationGraphQLResponse,
    ICreatePaymentMethodMutationVariables
  >({
    mutation: mutation ?? CREATE_PAYMENT_METHOD_MUTATION,
    options: {
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          subscriptions: {
            addPaymentMethod: { card: paymentMethod },
          },
        } = data;

        onCompleted({
          paymentMethod,
        });
      },
      onError,
    },
    token,
  });

  const handleCreatePaymentMethod = async ({ projectId, product, token: createdPaymentMethodToken }: IHandleCreatePaymentMethodParams) => {
    await executeCreatePaymentMethod({
      variables: {
        product,
        projectId,
        token: createdPaymentMethodToken,
      },
    });
  };

  return {
    handleCreatePaymentMethod,
    isLoading,
  };
};

export { useCreatePaymentMethod };
